(function () {
  'use strict';

  var DEFAULT_DISCOUNT_PCT = 10;
  var SUBSCRIPTION_DELIVERY_LEAD_DAYS = 2;
  var TARGET_REMAINING_DAYS = 4;

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      if (precision === undefined) precision = 2;
      if (thousands === undefined) thousands = ',';
      if (decimal === undefined) decimal = '.';

      if (isNaN(number) || number == null) {
        return '0';
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1] ? decimal + parts[1] : '';

      return whole + fraction;
    }

    switch ((formatString.match(placeholderRegex) || [null, 'amount'])[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function parseJsonScript(node) {
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (err) {
      return null;
    }
  }

  function toNumber(value) {
    var n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function normalizeText(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getTargetSubscriptionDays(days) {
    return clamp(
      Math.round(days) - SUBSCRIPTION_DELIVERY_LEAD_DAYS - TARGET_REMAINING_DAYS,
      7,
      540
    );
  }

  function uniq(values) {
    return Array.from(new Set(values));
  }

  function getCurrentLocale() {
    var raw =
      (window.Shopify && window.Shopify.locale) ||
      document.documentElement.getAttribute('lang') ||
      document.documentElement.getAttribute('xml:lang') ||
      'de';

    return String(raw).toLowerCase().split('-')[0];
  }

  function getRecommendedSuffix() {
    switch (getCurrentLocale()) {
      case 'it':
        return 'consigliato';
      case 'en':
        return 'recommended';
      case 'fr':
        return 'recommandé';
      case 'es':
        return 'recomendado';
      case 'nl':
        return 'aanbevolen';
      case 'pl':
        return 'zalecane';
      default:
        return 'empfohlen';
    }
  }

  function stripDiscountFromPlanName(planName) {
    var label = normalizeText(planName);

    label = label.replace(
      /\s*[,;|–—-]\s*\d+(?:[.,]\d+)?\s*%\s*(rabatt|discount|off|di sconto|de descuento|descuento|de réduction|reduction|réduction|korting|rabatu|rabat)\s*$/i,
      ''
    );

    label = label.replace(
      /\s+\d+(?:[.,]\d+)?\s*%\s*(rabatt|discount|off|di sconto|de descuento|descuento|de réduction|reduction|réduction|korting|rabatu|rabat)\s*$/i,
      ''
    );

    label = label.replace(/\s*[,;|–—-]\s*\d+(?:[.,]\d+)?\s*%\s*$/i, '');

    return normalizeText(label);
  }

  function parsePlanInterval(planName) {
    if (!planName) return null;

    var lower = normalizeText(planName).toLowerCase();

    if (
      /\b(jeden|jeder|jede|every)\s+monat\b/.test(lower) ||
      /\bmonatlich\b/.test(lower) ||
      /\bmonthly\b/.test(lower) ||
      /\bogni\s+mese\b/.test(lower) ||
      /\bmensile\b/.test(lower) ||
      /\bmensuel\b/.test(lower) ||
      /\bmensual\b/.test(lower) ||
      /\bmaandelijks\b/.test(lower)
    ) {
      return { unit: 'month', value: 1, days: 30 };
    }

    var monthMatch = lower.match(
      /(\d+(?:[.,]\d+)?)\s*(monat|monate|month|months|mese|mesi|mois|mes|meses|maand|maanden|miesiąc|miesiace|miesiące|miesiecy|miesięcy)/
    );
    if (monthMatch) {
      var months = clamp(Math.round(parseFloat(monthMatch[1].replace(',', '.'))), 1, 18);
      return { unit: 'month', value: months, days: months * 30 };
    }

    var weekMatch = lower.match(
      /(\d+(?:[.,]\d+)?)\s*(woche|wochen|week|weeks|settimana|settimane|semaine|semaines|semana|semanas|weken|tydzień|tydzien|tygodnie|tygodni|tyg)/
    );
    if (weekMatch) {
      var weeks = clamp(Math.round(parseFloat(weekMatch[1].replace(',', '.'))), 1, 78);
      return { unit: 'week', value: weeks, days: weeks * 7 };
    }

    var dayMatch = lower.match(
      /(\d+(?:[.,]\d+)?)\s*(tag|tage|day|days|giorno|giorni|jour|jours|día|dia|días|dias|dag|dagen|dzień|dzien|dni)/
    );
    if (dayMatch) {
      var days = clamp(Math.round(parseFloat(dayMatch[1].replace(',', '.'))), 1, 540);
      return { unit: 'day', value: days, days: days };
    }

    return null;
  }

  function formatIntervalLabel(interval) {
    if (!interval) return null;

    var locale = getCurrentLocale();
    var value = interval.value;

    if (interval.unit === 'month') {
      switch (locale) {
        case 'it':
          return 'Consegna ogni ' + value + ' ' + (value === 1 ? 'mese' : 'mesi');
        case 'en':
          return 'Every ' + value + ' ' + (value === 1 ? 'month' : 'months');
        case 'fr':
          return 'Livraison tous les ' + value + ' mois';
        case 'es':
          return 'Entrega cada ' + value + ' ' + (value === 1 ? 'mes' : 'meses');
        case 'nl':
          return 'Levering elke ' + value + ' ' + (value === 1 ? 'maand' : 'maanden');
        case 'pl':
          return 'Dostawa co ' + value + ' mies.';
        default:
          return 'Alle ' + value + ' ' + (value === 1 ? 'Monat' : 'Monate');
      }
    }

    if (interval.unit === 'week') {
      switch (locale) {
        case 'it':
          return 'Consegna ogni ' + value + ' ' + (value === 1 ? 'settimana' : 'settimane');
        case 'en':
          return 'Every ' + value + ' ' + (value === 1 ? 'week' : 'weeks');
        case 'fr':
          return 'Livraison toutes les ' + value + ' ' + (value === 1 ? 'semaine' : 'semaines');
        case 'es':
          return 'Entrega cada ' + value + ' ' + (value === 1 ? 'semana' : 'semanas');
        case 'nl':
          return 'Levering elke ' + value + ' ' + (value === 1 ? 'week' : 'weken');
        case 'pl':
          return 'Dostawa co ' + value + ' tyg.';
        default:
          return 'Alle ' + value + ' ' + (value === 1 ? 'Woche' : 'Wochen');
      }
    }

    if (interval.unit === 'day') {
      switch (locale) {
        case 'it':
          return 'Consegna ogni ' + value + ' ' + (value === 1 ? 'giorno' : 'giorni');
        case 'en':
          return 'Every ' + value + ' ' + (value === 1 ? 'day' : 'days');
        case 'fr':
          return 'Livraison tous les ' + value + ' ' + (value === 1 ? 'jour' : 'jours');
        case 'es':
          return 'Entrega cada ' + value + ' ' + (value === 1 ? 'día' : 'días');
        case 'nl':
          return 'Levering elke ' + value + ' ' + (value === 1 ? 'dag' : 'dagen');
        case 'pl':
          return 'Dostawa co ' + value + ' dni';
        default:
          return 'Alle ' + value + ' ' + (value === 1 ? 'Tag' : 'Tage');
      }
    }

    return null;
  }

  function pickPlansForVariant(variant) {
    var usedIds = {};
    var plans = [];

    (variant.plans || []).forEach(function (plan) {
      if (!plan || plan.id == null) return;

      var id = String(plan.id);
      if (usedIds[id]) return;
      usedIds[id] = true;

      var interval = parsePlanInterval(plan.name);
      plans.push({
        id: id,
        name: plan.name || '',
        price: toNumber(plan.price),
        interval: interval,
        days: interval ? interval.days : null,
      });
    });

    if (!plans.length) return [];

    plans.sort(function (a, b) {
      var hasA = Number.isFinite(a.days);
      var hasB = Number.isFinite(b.days);

      if (hasA && hasB) return a.days - b.days;
      if (hasA) return -1;
      if (hasB) return 1;

      return a.name.localeCompare(b.name);
    });

    if (plans.length > 3 && window.console && typeof window.console.warn === 'function') {
      window.console.warn('[XTRA Abo] Variant has more than 3 selling plans', {
        sku: variant.sku || '',
        plans: plans.map(function (plan) { return plan.name; }),
      });
    }

    var selected = plans.slice(0, 3);
    var recommendedPlan = selected[Math.floor(selected.length / 2)] || null;
    var recommendedSuffix = getRecommendedSuffix();

    return selected.map(function (plan) {
      var label = formatIntervalLabel(plan.interval) || stripDiscountFromPlanName(plan.name) || plan.name;
      var isRecommended = Boolean(recommendedPlan && plan.id === recommendedPlan.id);

      if (isRecommended) {
        label += ' (' + recommendedSuffix + ')';
      }

      return {
        id: plan.id,
        name: plan.name,
        label: label,
        days: plan.days,
        recommended: isRecommended,
      };
    });
  }

  function getProductScope(node) {
    if (!node || typeof node.closest !== 'function') return document;
    return node.closest('.product__meta') || node.closest('.shopify-section') || document;
  }

  function setVariantSavingsVisibility(root, hideSavings) {
    var scope = getProductScope(root);
    var shouldHide = Boolean(hideSavings);

    if (scope && scope.classList) {
      scope.classList.toggle('xtra-subscription-mode-active', shouldHide);
    }

    if (scope && typeof scope.querySelectorAll === 'function') {
      scope.querySelectorAll('[data-vdp]').forEach(function (bar) {
        bar.hidden = shouldHide;
        bar.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
      });
    }
  }

  function initWidget(root) {
    if (!root || root.dataset.xtraSubscriptionInitialized === 'true') return;

    var form = root.closest('[data-product-form]');
    var jsonNode = root.querySelector('[data-xtra-subscription-json]');

    if (!form || !jsonNode) return;

    var payload = parseJsonScript(jsonNode);
    if (!payload || !Array.isArray(payload.variants)) return;

    root.dataset.xtraSubscriptionInitialized = 'true';

    var variantsById = {};
    payload.variants.forEach(function (variant) {
      variantsById[String(variant.id)] = variant;
    });

    var defaultDiscountPct = toNumber(root.dataset.defaultDiscountPct) || DEFAULT_DISCOUNT_PCT;
    var defaultPurchaseMode = String(root.dataset.defaultPurchaseMode || 'onetime').toLowerCase() === 'subscription'
      ? 'subscription'
      : 'onetime';
    var moneyFormat = root.dataset.moneyFormat || (window.theme && window.theme.moneyFormat) || '${{amount}}';

    var hiddenSellingPlan = form.querySelector('[data-xtra-selling-plan-input]');
    var variantSelect = form.querySelector('[data-variant-select]');
    var onetimeRadio = root.querySelector('[data-xtra-purchase-option="onetime"]');
    var subscriptionRadio = root.querySelector('[data-xtra-purchase-option="subscription"]');
    var oneTimeRow = root.querySelector('[data-xtra-row="onetime"]');
    var subscriptionRow = root.querySelector('[data-xtra-row="subscription"]');
    var oneTimePrice = root.querySelector('[data-xtra-price-onetime]');
    var subscriptionPrice = root.querySelector('[data-xtra-price-subscription]');
    var comparePrice = root.querySelector('[data-xtra-price-compare]');
    var frequencySelect = root.querySelector('[data-xtra-frequency-select]');

    if (!hiddenSellingPlan || !variantSelect || !onetimeRadio || !subscriptionRadio || !frequencySelect) {
      return;
    }

    root.dataset.xtraUserModeLocked = root.dataset.xtraUserModeLocked || '0';

    function lockUserModeChoice() {
      root.dataset.xtraUserModeLocked = '1';
    }

    function setModeUi(isSubscriptionActive, subscriptionEnabled) {
      root.classList.toggle('is-subscription', isSubscriptionActive && subscriptionEnabled);
      root.classList.toggle('is-onetime', !isSubscriptionActive || !subscriptionEnabled);
      root.dataset.xtraPurchaseMode = isSubscriptionActive && subscriptionEnabled ? 'subscription' : 'onetime';

      oneTimeRow.classList.toggle('is-active', !isSubscriptionActive || !subscriptionEnabled);
      subscriptionRow.classList.toggle('is-active', isSubscriptionActive && subscriptionEnabled);

      frequencySelect.disabled = !subscriptionEnabled;
      subscriptionRow.classList.toggle('is-disabled', !subscriptionEnabled);
      setVariantSavingsVisibility(root, isSubscriptionActive && subscriptionEnabled);
    }

    function syncHiddenSellingPlan() {
      var subscriptionEnabled = frequencySelect.options.length > 0 && Boolean(frequencySelect.value);
      var wantsSubscription = subscriptionRadio.checked && subscriptionEnabled;

      if (wantsSubscription) {
        hiddenSellingPlan.value = frequencySelect.value || '';
      } else {
        hiddenSellingPlan.value = '';
      }

      setModeUi(wantsSubscription, subscriptionEnabled);

      root.dispatchEvent(new CustomEvent('xtra:subscription-change', {
        bubbles: true,
        detail: {
          purchaseMode: wantsSubscription ? 'subscription' : 'onetime',
          sellingPlanId: hiddenSellingPlan.value || '',
          subscriptionEnabled: subscriptionEnabled,
          variantId: root.dataset.currentVariantId || '',
        },
      }));
    }

    function renderPrices(variant) {
      var variantPrice = toNumber(variant.price);
      var discounted = Math.round(variantPrice * (100 - defaultDiscountPct) / 100);
      var formattedVariantPrice = variant.priceFormatted || formatMoney(variantPrice, moneyFormat);
      var formattedSubscriptionPrice = variant.subscriptionPriceFormatted || formatMoney(discounted, moneyFormat);

      if (oneTimePrice) {
        oneTimePrice.textContent = formattedVariantPrice;
      }

      if (subscriptionPrice) {
        subscriptionPrice.textContent = formattedSubscriptionPrice;
      }

      if (comparePrice) {
        comparePrice.textContent = formattedVariantPrice;
      }
    }

    function renderPlanOptions(variant) {
      var plans = pickPlansForVariant(variant);

      frequencySelect.innerHTML = '';

      plans.forEach(function (plan) {
        var option = document.createElement('option');
        option.value = plan.id;
        option.textContent = plan.label;
        frequencySelect.appendChild(option);
      });

      if (!plans.length) {
        var fallback = document.createElement('option');
        fallback.value = '';
        fallback.textContent = 'Kein Abo-Intervall verfügbar';
        frequencySelect.appendChild(fallback);
        frequencySelect.value = '';
        return false;
      }

      frequencySelect.disabled = false;
      frequencySelect.removeAttribute('disabled');
      subscriptionRow.classList.remove('is-disabled');

      var recommended = plans.find(function (plan) { return plan.recommended; });

      if (recommended) {
        frequencySelect.value = recommended.id;
      } else {
        frequencySelect.selectedIndex = 0;
      }

      return true;
    }

    function updateVariant(variantId) {
      var variant = variantsById[String(variantId)];
      if (!variant) return;

      root.dataset.currentVariantId = String(variant.id);
      renderPrices(variant);

      var variantAvailable = variant.available !== false;
      var hasPlans = false;

      if (variantAvailable) {
        hasPlans = renderPlanOptions(variant);
      } else {
        frequencySelect.innerHTML = '';
        var soldOutFallback = document.createElement('option');
        soldOutFallback.value = '';
        soldOutFallback.textContent = 'Abo aktuell nicht verfügbar';
        frequencySelect.appendChild(soldOutFallback);
        frequencySelect.value = '';
      }

      root.hidden = !hasPlans;

      onetimeRadio.disabled = Boolean(variant.requiresSellingPlan);

      if (!hasPlans) {
        subscriptionRadio.checked = false;
        onetimeRadio.checked = true;
        hiddenSellingPlan.value = '';
        setVariantSavingsVisibility(root, false);
        setModeUi(false, false);
        return;
      }

      var wantsSubscription = false;
      if (hasPlans) {
        if (variant.requiresSellingPlan) {
          wantsSubscription = true;
        } else if (root.dataset.xtraUserModeLocked === '1') {
          wantsSubscription = Boolean(subscriptionRadio.checked);
        } else {
          wantsSubscription = defaultPurchaseMode === 'subscription';
        }
      }

      subscriptionRadio.checked = wantsSubscription;
      onetimeRadio.checked = !wantsSubscription;

      syncHiddenSellingPlan();
    }

    oneTimeRow.addEventListener('click', function (event) {
      if (event.target.closest('input, select, option, button, a, label')) return;
      if (onetimeRadio.disabled) return;
      onetimeRadio.checked = true;
      lockUserModeChoice();
      syncHiddenSellingPlan();
    });

    subscriptionRow.addEventListener('click', function (event) {
      if (event.target.closest('input, select, option, button, a, label')) return;
      if (frequencySelect.disabled) return;
      subscriptionRadio.checked = true;
      lockUserModeChoice();
      syncHiddenSellingPlan();
    });

    onetimeRadio.addEventListener('change', function () {
      lockUserModeChoice();
      syncHiddenSellingPlan();
    });

    subscriptionRadio.addEventListener('change', function () {
      lockUserModeChoice();
      syncHiddenSellingPlan();
    });

    frequencySelect.addEventListener('change', function () {
      subscriptionRadio.checked = true;
      lockUserModeChoice();
      syncHiddenSellingPlan();
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', function (event) {
        updateVariant(event.target.value);
      });
    }

    root.__xtraSubscriptionUpdateVariant = updateVariant;
    updateVariant(root.dataset.currentVariantId || variantSelect.value);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-xtra-subscription]').forEach(initWidget);
  }

  function syncFromVariantChange(variantId) {
    if (!variantId) return;

    document.querySelectorAll('[data-xtra-subscription]').forEach(function (root) {
      if (typeof root.__xtraSubscriptionUpdateVariant !== 'function') return;

      var payload = parseJsonScript(root.querySelector('[data-xtra-subscription-json]'));
      if (!payload || !Array.isArray(payload.variants)) return;

      var hasVariant = payload.variants.some(function (variant) {
        return String(variant.id) === String(variantId);
      });

      if (hasVariant) {
        root.__xtraSubscriptionUpdateVariant(String(variantId));
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('product:variant-change', function (event) {
    var variant = event.detail && event.detail.variant;
    var variantId = variant && variant.id ? String(variant.id) : '';

    if (!variantId) return;

    var scope = getProductScope(event.target || document);
    scope.querySelectorAll('[data-xtra-subscription]').forEach(function (root) {
      if (typeof root.__xtraSubscriptionUpdateVariant === 'function') {
        root.__xtraSubscriptionUpdateVariant(variantId);
      }
    });

    syncFromVariantChange(variantId);
  });

  document.addEventListener('quickview:loaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
